module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "table_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.srcdata,
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.row_click
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": _vm.fieldmap[0].key,
      "label": _vm.fieldmap[0].name,
      "min-width": _vm.fieldmap[0].width
    }
  }), _vm._v(" "), _vm._l((_vm.fieldmap.slice(1)), function(item) {
    return _c('el-table-column', {
      key: item.key,
      attrs: {
        "prop": item.key,
        "label": item.name,
        "width": item.width
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1fa83336"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SimpleTable.vue
// module id = 251
// module chunks = 2